var exports = {
  "P": "Aligned__YTqQqA",
};

module.exports = exports;
